export const COL_COUNT = 5;

export const SHEET_REVIEW_UI_PAGE_SIZE = 50;

export const SHEET_REVIEW_TABLE_SCROLL_OFFSET_PX = 80;

export const defaultSuccessContinueLabel = 'Ir a Gestión → Mi comercio';

export const profileMaterialsHint =
  'Podés revisar el listado completo en tu perfil, pestaña Gestión → Mi comercio.';

export const addMaterialPopupVariants = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: { opacity: 1, scale: 1 },
};
